import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface'
import { DeviceBehfa_Interface } from './DeviceBehfa_Interface'
import { Empty_FlowchartPaper_Interface, FlowchartPaper_Interface } from './FlowchartPaper_Interface'

export interface LetterRequestCustomer_Schedule_Interface {
    id:number,
    persianDate:string,
    persianDate2:string,
    dsc:string,
    startDate:Number,
    endDate:Number,
    comment:number,
    status:boolean,
    del:boolean,
    sms:boolean,
    showPrint:boolean,
    isOut:boolean,
 
    letterCode:string,
    customerName:string,


    done?:boolean,
    expert:Array<ExpertCalibration_Interface>,
    deviceBehfa:Array<DeviceBehfa_Interface>,
    fullname:string,
    statusStr:string,
    flowchart:FlowchartPaper_Interface,
}

export function Empty_LetterRequestCustomer_Schedule_Interface():LetterRequestCustomer_Schedule_Interface{
    return{
      id:0,
      status:false,
      del:false,
      sms:false,
      isOut:false,
      showPrint:true,

      letterCode:'',
      customerName:'',

      done:null,
      persianDate:'',
      persianDate2:'',
      dsc:'',
      startDate:0,
      endDate:0,
      comment:0,
      expert:[],
      deviceBehfa:[],
      fullname:'',
      statusStr:'',
      flowchart:Empty_FlowchartPaper_Interface()
    }
  }
